'use client';
import { useState } from 'react';
import Image from 'next/image';
import { HiOutlinePlayCircle } from 'react-icons/hi2';

import { TeamMember } from './DuoTeamMember';
import ScrollWithCarets from 'src/components/ScrollWithCarets';
import VideoPlayer from './VideoPlayer';

type Props = {
    members: TeamMember[];
};

export default function VideoCarousel({ members }: Props) {
    const [selectedMember, setSelectedMember] = useState<TeamMember | null>(null);

    const closePlayer = () => {
        setSelectedMember(null);
    };

    return (
        <>
            <ScrollWithCarets>
                <div className="container relative mx-auto my-16 overflow-visible">
                    <ul className="flex flex-nowrap gap-x-4 p-4 md:after:pr-14">
                        {members
                            .sort((a, b) => a.position - b.position)
                            .map((member) => (
                                <li
                                    data-carousel-item
                                    key={member.avatar}
                                    onClick={() => {
                                        setSelectedMember(member);
                                    }}
                                    className="w-full flex-none cursor-pointer snap-center shadow-md md:w-1/2 lg:w-1/3 xl:w-1/4">
                                    <div className="relative h-[200px]">
                                        <Image
                                            className="object-cover"
                                            alt={`Video ${member.name}`}
                                            src={`/images/campaigns/30years/thumb-${member.avatar}`}
                                            fill
                                        />
                                        <div className="bg-dark-green/30 absolute left-0 top-0 flex h-full w-full items-center justify-center text-center text-4xl text-white hover:opacity-0">
                                            <HiOutlinePlayCircle />
                                        </div>
                                    </div>
                                    <div className="font-display p-4 text-xl">{member.name}</div>
                                </li>
                            ))}
                    </ul>
                </div>
            </ScrollWithCarets>
            <VideoPlayer source={selectedMember?.video || null} onClose={closePlayer} />
        </>
    );
}
